import { createFileRoute, Outlet } from "@tanstack/react-router";
import { TableHeader } from "@/components/Organisms/TableHeader/TableHeader";
import { useAppTranslation } from "@/hooks/use-app-translation";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/settings",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useAppTranslation();
	return (
		<div className="space-y-0 h-full">
			<div className="space-y-4 mt-4">
				<TableHeader
					title={t("admin.nav.items.settings.label")}
					description={t("admin.settings.description")}
				/>
			</div>

			<Outlet />
		</div>
	);
}
